import { ESSAYS } from './data';
export default function Thinking() {
  return (
    <div className="bg-[#F0EBE0] text-[#1B2D8C] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[3px] border-[#1B2D8C]">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#1B2D8C]/65 mb-3">— § 03 / Thinking · Studio essays</p>
        <h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">Eight essays<br />on the studio.</h1>
      </section>
      <section className="max-w-[1100px] mx-auto px-8 lg:px-14 py-12 divide-y divide-[#1B2D8C]/20">
        {ESSAYS.map(e => (
          <article key={e.iss} className="grid md:grid-cols-[120px_1fr] gap-8 py-9 items-baseline">
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#FFC700] bg-[#1B2D8C] px-2 py-1 w-fit">No. {e.iss}</div>
            <div>
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1B2D8C]/55">{e.date} · {e.cat}</p>
              <h2 className="font-serif italic text-3xl lg:text-5xl leading-[1.04] mt-2">{e.t}</h2>
              <p className="font-sans text-base text-[#1B2D8C]/65 mt-3 leading-[1.7]">{e.d}</p>
              <button data-testid={`vsp-essay-${e.iss}`} className="mt-5 font-mono text-[10px] tracking-[0.32em] uppercase border-b-2 border-[#1B2D8C] text-[#1B2D8C] pb-1 hover:text-[#FFC700] hover:border-[#FFC700]">Read essay →</button>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
